import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import Pos from '../pages/pos';
import Checkout from '../pages/pos/checkout';
import Receipt from '../pages/pos/receipt';

export function PointSales() {
  return (
    <Routes>
      <Route path='/' element={<Index child={<Pos />}/>} />
      <Route path='/checkout' element={<Index child={<Checkout />}/>} />
      <Route path='/receipt' element={<Index child={<Receipt />}/>} />
    </Routes>
  );
}
